import { render } from "./Dispatch.vue?vue&type=template&id=3fb82f0e&scoped=true&ts=true"
import script from "./Dispatch.ts?vue&type=script&lang=ts"
export * from "./Dispatch.ts?vue&type=script&lang=ts"

import "./Dispatch.scss?vue&type=style&index=0&id=3fb82f0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb82f0e"]])

export default __exports__